(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/react/components/result-draw-start-secondary.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/react/components/result-draw-start-secondary.js');

'use strict';

const ResultDrawStart = svs.lyckoplatsen.components.shared_result.react.components.ResultDrawStart;
const ResultDrawStartSecondary = _ref => {
  let setResultDrawStartVisible = _ref.setResultDrawStartVisible;
  return React.createElement("div", {
    className: "lp-draw-start-secondary map-gradient gsap-start-secondary"
  }, React.createElement("div", {
    className: "start-body"
  }, React.createElement(ResultDrawStart, {
    setResultDrawStartVisible: setResultDrawStartVisible
  })));
};
Object.assign(svs.lyckoplatsen.components.shared_result.react.components, {
  ResultDrawStartSecondary
});

 })(window);